import { PROJECT_SERVICE, USER_SERVICE } from "../consts";

export const DASHBOARD_SERVICE = `${PROJECT_SERVICE}dashboard/admin/`;
export const DASHBOARD_ADMIN_SUMMARY_API = `${DASHBOARD_SERVICE}summary`;
export const DASHBOARD_ADMIN_SITE_MANAGER_MONITORING_API = (projectId: string) => `${DASHBOARD_SERVICE}projects/${projectId}/site-manager-monitoring`;
export const DASHBOARD_ADMIN_PROJECT_HEALTH_API = `${DASHBOARD_SERVICE}project-health`;
export const DASHBOARD_ADMIN_ACTIVE_PROJECTS_API = `${DASHBOARD_SERVICE}active-projects`;
export const DASHBOARD_ADMIN_ACTION_QUEUE_API = `${DASHBOARD_SERVICE}action-queue`;
export const DASHBOARD_ADMIN_SAFETY_COMPLIANCE_API = `${DASHBOARD_SERVICE}safety-compliance`;
export const DASHBOARD_ADMIN_QUALITY_CONTROL_API = `${DASHBOARD_SERVICE}quality-control`;
export const DASHBOARD_ADMIN_WORKFORCE_OVERVIEW_API = `${USER_SERVICE}workforce/summary`;
export const DASHBOARD_ADMIN_SAFETY_AUDIT_SUMMARY_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/safety-audit-summary`;
export const DASHBOARD_ADMIN_QUALITY_AUDIT_SUMMARY_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/quality-audit-summary`;

export const DASHBOARD_ADMIN_PROJECT_PLAN_BY_STATUS_API = (projectId: string, status: string) =>
  `${PROJECT_SERVICE}projects/${projectId}/plans/status/${status}`;
export const DASHBOARD_ADMIN_UPCOMING_EVENTS_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/upcoming-events`;
export const DASHBOARD_ADMIN_CLIENT_SHARED_PHOTOS_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/client-photos`;
export const DASHBOARD_ADMIN_SCHEDULE_VARIANCE_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/schedule-variance`;
export const DASHBOARD_ADMIN_OVERVIEW_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/overview`;
export const DASHBOARD_ADMIN_CATEGORY_PERFORMANCE_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/category-performance`;
export const DASHBOARD_ADMIN_CLOSURE_READINESS_API = (projectId: string) =>
  `${DASHBOARD_SERVICE}projects/${projectId}/closure-readiness`;

export const DASHBOARD_ADMIN_REVIEW_ATTACHMENT_API = (projectId: string, taskId: string, attachmentId: string) =>
  `${PROJECT_SERVICE}projects/${projectId}/tasks/${taskId}/attachments/${attachmentId}/review`;
export const DASHBOARD_ADMIN_DELETE_ATTACHMENT_API = (projectId: string, taskId: string, attachmentId: string) =>
  `${PROJECT_SERVICE}projects/${projectId}/tasks/${taskId}/attachments/${attachmentId}`;